import {useQuery} from "@tanstack/react-query";
import {getPublicLotteryGamesService} from "../services/getPublicLotteryGames.service";

const LOTTERY_CDN_BASE = "https://images.cdn.jogacompix.com";

function resolveLotteryLogoUrl(logo) {
  if (logo == null) return null;
  const s = String(logo).trim();
  if (!s) return null;
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  return `${LOTTERY_CDN_BASE}/${s.replace(/^\/+/, "")}`;
}

const useGetPublicLotteryGames = () => {
  const {data, isPending, error} = useQuery({
    queryKey: ["public-lottery-games"],
    queryFn: getPublicLotteryGamesService,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    select: responseData => {
      const gamesList = responseData?.data?.data || [];
      if (!Array.isArray(gamesList)) return [];

      if (import.meta.env.DEV) {
        const withoutLogo = gamesList.filter(game => resolveLotteryLogoUrl(game.logo) == null);
        if (withoutLogo.length > 0) {
          console.warn(
            `[public-lottery-games] ${withoutLogo.length}/${gamesList.length} ítems sin logo en API (UI usa fallback):`,
            withoutLogo.map(g => ({id: g.id, name: g.name}))
          );
        }
      }

      return gamesList.map((game, index) => ({
        id: game.id,
        name: game.name,
        logo: resolveLotteryLogoUrl(game.logo),
        uniqueId: `lottery-${game.id}-${index}`,
      }));
    },
  });

  return {
    games: data || [],
    isPending,
    error,
  };
};

export default useGetPublicLotteryGames;
